import { Injectable, inject } from '@angular/core';

import { EventMediaHelperService, EventMediaTracking } from '@frontend/sports/betting-offer/feature/media';
import { EventDetailsColumnType } from '@frontend/sports/betting-offer/feature/model';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { getStatsIcon } from '@frontend/sports/common/core/feature/icon';
import { GridEvent, GridMedia } from '@frontend/sports/grid/core/feature/model';
import { MediaEventSource } from '@frontend/sports/grid/media/feature/model';
import { MediaApiService } from '@frontend/sports/grid/media/feature/state';
import { TrackingService, TrackingVideoSource, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({ providedIn: 'root' })
export class EventMediaService {
    trackingService = inject(TrackingService);
    protected eventAvailability = inject(EventMediaHelperService);
    private mediaApi = inject(MediaApiService);

    hasVideo(event: GridEvent): boolean {
        return this.eventAvailability.hasLiveVideo(event);
    }

    hasAnimation(event: GridEvent): boolean {
        return this.eventAvailability.hasAnimationOrSimulation(event);
    }

    hasStats(event: GridEvent): boolean {
        return this.eventAvailability.hasStats(event);
    }

    statsActive(event: GridEvent, media: GridMedia): boolean {
        return media.statsEvent === event.id;
    }

    getStatsIcon(isActive: boolean): string {
        return getStatsIcon(isActive);
    }

    videoActive(event: GridEvent, media: GridMedia): boolean {
        return media.videoEvent === event.id;
    }

    animationActive(event: GridEvent, media: GridMedia): boolean {
        return media.animationEvent === event.id;
    }

    activateMedia(activeType: EventDetailsColumnType, event: GridEvent, media: GridMedia, isDeactivate = false, _isRedirectHome = false): boolean {
        if (isDeactivate) {
            return false;
        }
        const isActive =
            (this.statsActive(event, media) && activeType === EventDetailsColumnType.Stats) ||
            (this.videoActive(event, media) && activeType === EventDetailsColumnType.Video) ||
            (this.animationActive(event, media) && activeType === EventDetailsColumnType.Animation);

        if (!isActive) {
            const statsIconGridClicked = (sportId: number): string => `Bet_Radar_GridStats_EventView_SB_ ${sportId}_Click`;
            const iconClickTrackingEvent = {
                [EventDetailsColumnType.Video]: 'VideoIcon_Grid_Clicked',
                [EventDetailsColumnType.Animation]: 'AnimationIcon_Grid_Clicked',
                [EventDetailsColumnType.Stats]: (sportId: number): string => statsIconGridClicked(sportId),
            };

            if (iconClickTrackingEvent[activeType]) {
                this.trackingService.track(trackingConstants.EVENT_MEDIA, {
                    [trackingConstants.COMPONENT_SITE_ELEMENT_INTERCATIONS]:
                        activeType === EventDetailsColumnType.Stats
                            ? iconClickTrackingEvent[EventDetailsColumnType.Stats](event.sport.id)
                            : iconClickTrackingEvent[activeType],
                });
            }

            this.setEventId(event.id, activeType);
        }

        return false;
    }

    protected setEventId(eventId: string, tab: EventDetailsColumnType): void {
        this.mediaApi.setEventId(eventId, MediaEventSource.Grid, tab, TrackingVideoSource.Grid);
    }

    trackChanges(activeType: EventDetailsColumnType, event: GridEvent, mediaTracking: EventMediaTracking, _isDeselect = false) {
        const iconClickTrackingEvent = {
            [EventDetailsColumnType.Video]: 'VideoIcon',
            [EventDetailsColumnType.Animation]: 'AnimationIcon',
            [EventDetailsColumnType.Stats]: 'StatsIcon',
        };

        const eventDetails = event.sport.id === SportConstant.Golf ? 'IMG' : iconClickTrackingEvent[activeType];

        this.trackingService.track(eventDetails, mediaTracking);
    }
}
